import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { authActions } from "../store";

const Logout = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    // Clear all relevant items from localStorage
    localStorage.removeItem("company_id");
    localStorage.removeItem("company_name");
    localStorage.removeItem("email_id");
    localStorage.removeItem("isLoggedIn");
    localStorage.removeItem("packages");
    localStorage.removeItem("token");
    localStorage.removeItem("user_id");


     localStorage.clear();

    // Dispatch the logout action to update Redux state
    dispatch(authActions.logout());

    // Redirect to login page
    history.push("/login");
  }, [dispatch, history]);

  return null;
};

export default Logout;
